import { createGlobalStyle } from "styled-components";

// Fonts //
import RealtimeTextRegular from './fonts/realtimetext-regular.woff';
import RealtimeTextRegular2 from './fonts/realtimetext-regular.woff2';
import RealtimeTextSemibold from './fonts/realtimetext-semibold.woff';
import RealtimeTextSemibold2 from './fonts/realtimetext-semibold.woff2';
import RealtimeTextBold from './fonts/realtimetext-bold.woff';
import RealtimeTextBold2 from './fonts/realtimetext-bold.woff2';
import RealtimeRoundedBold from './fonts/realtimerounded-bold.woff';
import RealtimeRoundedBold2 from './fonts/realtimerounded-bold.woff2';
import RealtimeRoundedBlack from './fonts/realtimerounded-black.woff';
import RealtimeRoundedBlack2 from './fonts/realtimerounded-black.woff2';
import RealtimeRegular from './fonts/realtime-regular.woff';
import RealtimeRegular2 from './fonts/realtime-regular.woff2';
import RealtimeBold from './fonts/realtime-bold.woff';
import RealtimeBold2 from './fonts/realtime-bold.woff2';

/* eslint no-unused-expressions: 0 */
export default createGlobalStyle`

  @font-face {
    font-family: 'Realtime Text';
    src: url(${ RealtimeTextRegular2 }) format('woff2'),
         url(${ RealtimeTextRegular }) format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime Text';
    src: url(${ RealtimeTextSemibold2 }) format('woff2'),
         url(${ RealtimeTextSemibold }) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime Text';
    src: url(${ RealtimeTextBold2 }) format('woff2'),
         url(${ RealtimeTextBold }) format('woff');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime Rounded';
    src: url(${ RealtimeRoundedBold2 }) format('woff2'),
         url(${ RealtimeRoundedBold }) format('woff');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime Rounded';
    src: url(${ RealtimeRoundedBlack2 }) format('woff2'),
         url(${ RealtimeRoundedBlack }) format('woff');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime';
    src: url(${ RealtimeRegular2 }) format('woff2'),
         url(${ RealtimeRegular }) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Realtime';
    src: url(${ RealtimeBold2 }) format('woff2'),
         url(${ RealtimeBold }) format('woff');
    font-weight: 800;
    font-style: normal;
  }

  * {
    outline: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

  html {
    height: 100%;
    width: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100%;
    width: 100%;
    background-color: #fff;
  }

  #root {
    display: flex;
    min-height: 100vh;
    max-width: 1680px;
    margin: 0 auto;
    overflow-x: hidden;
    z-index: 0;
  }

  button {
    font-family: inherit;
    text-transform: uppercase;
  }

  button.str-chat__message-replies-count-button {
    border: none;
    background: none;
    padding: 0;
    margin-top: 8px;
    font-size: 12px;
    line-height: 15px;
    font-weight: 700;
    color: #006cff;
    cursor: pointer;
    text-transform: unset;
  }

  .str-chat__message-actions-list button  {
    text-transform: unset;
  }


  h1, h2, h3,
  h4, h5, h6 {
    margin: 0;
  }

  p,
  label {
    margin: 0;
  }

  a {
    color: ${ ({ theme }) => theme.color.primary };
    text-decoration: none;
  }

  .ReactModal__Overlay {
    z-index: 1000;
  }

  .str-chat {
    height: auto !important;
  }

  .str-chat-channel {
    max-height: 100vh;
    height: 100% !important;
  }
  .str-chat-channel.messaging .str-chat__main-panel {
    padding: 0!important;
  }
  .str-chat__message .str-chat__reaction-list li button, .str-chat__message .str-chat__reaction-list li button {
    background: none;
    border: 0;
  }
  .str-chat__message-reactions-list-item button {
    background: none;
    border: 0;
  }
`;
